"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _Collapse = _interopRequireDefault(require("../Collapse/Collapse"));

var _MorphIcon = _interopRequireDefault(require("../Icons/MorphIcon"));

var _settings = require("./settings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DismissibleNotification =
/*#__PURE__*/
function (_Component) {
  _inherits(DismissibleNotification, _Component);

  function DismissibleNotification(props) {
    var _this;

    _classCallCheck(this, DismissibleNotification);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DismissibleNotification).call(this, props));
    _this.state = {
      isOpen: true
    };
    _this._morphCloseStyle = {
      position: 'absolute',
      top: 0,
      right: 0,
      margin: '14px'
    };
    return _this;
  }

  _createClass(DismissibleNotification, [{
    key: "onClose",
    value: function onClose(event) {
      event.preventDefault();
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_Collapse.default, {
        isOpen: this.state.isOpen,
        transitionTime: this.props.transitionTime,
        transitionCloseTime: this.props.transitionCloseTime,
        easing: this.props.easing,
        isLazyRender: this.props.isLazyRender,
        openedClassName: this.props.openedClassName,
        collapsedClassName: this.props.collapsedClassName,
        onClose: this.props.onClose
      }, _react.default.createElement(_Notification.default, {
        type: this.props.type,
        className: this.props.className,
        visible: true,
        icon: this.props.icon,
        size: this.props.size,
        align: this.props.align
      }, this.props.children, _react.default.createElement("button", {
        type: "button",
        style: this._morphCloseStyle,
        onClick: function onClick(event) {
          return _this2.onClose(event);
        }
      }, _react.default.createElement(_MorphIcon.default, {
        size: "small",
        type: "close"
      }))));
    }
  }]);

  return DismissibleNotification;
}(_react.Component);

DismissibleNotification.defaultProps = {
  transitionTime: 500,
  easing: 'ease-out'
};
DismissibleNotification.propTypes = {
  /**
   * The type of notification component (Warning, Information, Error, Success)
   */
  type: _propTypes.default.oneOf(_settings.notificationTypeList).isRequired,

  /**
   * Css classes that can get applied to the component
   */
  className: _propTypes.default.string,

  /**
   * Child components that will get rendered in the notification
   */
  children: _propTypes.default.node,

  /**
   * Determines whether an icon should be visible or not
   */
  icon: _propTypes.default.bool,

  /**
   * Change the size of the notification
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * Change the alignment of components inside the notification
   */
  align: _propTypes.default.oneOf(['center', 'bottom']),

  /**
   * The time in milliseconds it takes to collapse the notification. Defaults to 500ms
   */
  transitionTime: _propTypes.default.number,

  /**
   * The number of milliseconds for the close transition to take. Defaults to transitionTime
   */
  transitionCloseTime: _propTypes.default.number,

  /**
   * The CSS easing method you wish to apply to the open/close transition.
   * This string can be any valid value of CSS transition-timing-function.
   * Defaults to ease-out
   * For reference view the MDN documentation https://developer.mozilla.org/en-US/docs/Web/CSS/transition-timing-function
   */
  easing: _propTypes.default.string,

  /**
   * Set this to true to postpone rendering of all of the content of the component
   * until before it's opened for the first time. Defaults to false
   */
  isLazyRender: _propTypes.default.bool,

  /**
   * Add this class name to the root element when the component is opened
   */
  openedClassName: _propTypes.default.string,

  /**
   * Add this class name to the root element when the component is dismissed
   */
  collapsedClassName: _propTypes.default.string,

  /**
   * A function that is called when the component has finished collapsing
   */
  onClose: _propTypes.default.func
};
var _default = DismissibleNotification;
exports.default = _default;